import { z } from "zod";

export const siteSurveySchema = z.object({
  floorDetails: z.string().min(1, "Floor Details are required"),
  existingPowerConsumption: z.preprocess((val) => (val === "" ? undefined : val), z.union([z.string().min(1, "Existing consumption is required"), z.number()])),
  VerveCapacityRequested: z.preprocess((val) => (val === "" ? undefined : val), z.union([z.string().min(1, "Recommended capacity is required"), z.number()])),
  existingPowerPaid: z.preprocess((val) => (val === "" ? undefined : val), z.union([z.string().min(1, "Last bill amount is required"), z.number()])),
  notes: z.string().optional(),
  files: z.array(z.any()).max(25, "Maximum 25 files allowed"),
});
